// Collection filters: submit the GET filter form when a checkbox, price, or sort changes.
(() => {
  const form = document.querySelector('form[data-auto-submit]');
  const sort = document.querySelector('[data-sort]');
  if (sort && form) {
    // The hidden sort_by inside the form would duplicate the select's value; keep one.
    sort.addEventListener('change', () => { form.querySelector('input[name="sort_by"]')?.remove(); form.requestSubmit(); });
  }
  if (!form) return;
  let timer;
  form.addEventListener('change', (e) => {
    clearTimeout(timer);
    // Give price inputs a moment so typing "25" doesn't submit "2".
    timer = setTimeout(() => form.requestSubmit(), e.target.type === 'number' ? 700 : 0);
  });
  form.addEventListener('submit', () => {
    // Drop empty price fields so URLs stay clean.
    form.querySelectorAll('input[type="number"]').forEach((i) => { if (!i.value) i.disabled = true; });
  });
})();
